import { render, staticRenderFns } from "./leaveIntership.vue?vue&type=template&id=c0777924&scoped=true&"
import script from "./leaveIntership.vue?vue&type=script&lang=js&"
export * from "./leaveIntership.vue?vue&type=script&lang=js&"
import style0 from "./leaveIntership.vue?vue&type=style&index=0&id=c0777924&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0777924",
  null
  
)

export default component.exports